import { connect } from "react-redux";
import get from "lodash/get";

import {
  downloadSavedReport as onDownloadSavedReport,
  clearDownloadSavedReport as onClearDownloadSavedReport,
} from "../../actions/downloadSavedReportActions";

const mapStateToProps = (state) => ({
  downloadSavedReportData: state.downloadSavedReport.dataState,
});

const mapDispatchToProps = {
  onDownloadSavedReport,
  onClearDownloadSavedReport,
};

const withDownloadSavedReport = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withDownloadSavedReport };
